import { m } from 'framer-motion';
import { styled } from '@mui/material/styles';
import { Container } from '@mui/system';
import { Grid, Typography } from '@mui/material';
import { PropTypes } from 'prop-types';
//  import { varFade } from '../../animate';
import MotionViewport from '../../animate/MotionViewport';
import ImgBox from '../Box/ImgBox';

DetailMedia.propTypes = {
  media: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  description: PropTypes.string,
};

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(2, 0),
  backgroundColor: theme.palette.background.paper,
}));

export default function DetailMedia({ media, description }) {
  return (
    <RootStyle className="printable">
      <Container component={MotionViewport} sx={{ position: 'relative', height: '100%' }}>
        <m.div /* variants={varFade().inUp} */>
          <Grid container>
            <Grid item xs={12} className="text-center">
              <ImgBox
                className="border-radius-12"
                sx={{ maxWidth: '100%', margin: 'auto' }}
                src={media !== undefined ? `${process.env.REACT_APP_API_URL}/image/download/${media}?sizeIndex=0` : ''}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} className="text-center">
              <Typography variant="subtitle2" sx={{ padding: '6px' }}>
                {description}
              </Typography>
            </Grid>
          </Grid>
        </m.div>
      </Container>
    </RootStyle>
  );
}
